// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ov-c";
export var backButton = "_ov-4";
export var backIcon = "_ov-5";
export var chevronShortcut = "_ov-6";
export var container = "_ov-1";
export var editor = "_ov-8";
export var editorWrapper = "_ov-7";
export var prefix = "_ov-2";
export var searchIcon = "_ov-3";
export var suffix = "_ov-9";
export var suffixContent = "_ov-a";
export var suffixText = "_ov-b";
export var wrapper = "_ov-0";